// Public
export const EMPTY = "";
export const PUBLIC_BASE = "/";
export const LOGIN = PUBLIC_BASE + "login";
export const TERMS = PUBLIC_BASE + "terms";
export const PRIVACY = PUBLIC_BASE + "privacy";
export const FORGOT_PASSWORD = PUBLIC_BASE + "forgot";
export const RESTORE_PASSWORD = PUBLIC_BASE + "restore";

// Private
export const PRIVATE_BASE = PUBLIC_BASE + "adq";
export const HOME = PRIVATE_BASE + "/home";

// Main sections
export const TOOLS = `${PRIVATE_BASE}/tools`;
export const DASHBOARDS = `${PRIVATE_BASE}/dashboards`;
export const DATA_EXPLORERS = `${PRIVATE_BASE}/data-explorers`;

// Dashboards items
export const DASHBOARDS_ITEMS = `${PRIVATE_BASE}/dashboards-items`;
export const DASHBOARDS_ACTIONS_PERFORMANCE = `${DASHBOARDS_ITEMS}/actions-performance`;
export const DASHBOARDS_DATA_ALERTS = `${DASHBOARDS_ITEMS}/data-alerts-performance`;

// Data explorer items
export const DATA_EXPLORERS_ITEMS = `${PRIVATE_BASE}/data-explorers-items`;
export const DATA_EXPLORERS_ACTIONS_PERFORMANCE = `${DATA_EXPLORERS_ITEMS}/actions-performance`;
export const TACTIC_LINES_PERFORMANCE = `${DATA_EXPLORERS_ITEMS}/tactic-lines-performance`;
export const DATA_LIBRARY = `${DATA_EXPLORERS_ITEMS}/data-library`;
export const DATA_LIBRARY_DOCS = `${DATA_LIBRARY}/:id/docs`;
export const resolveDataLibraryDocs = (id) => {
  return DATA_LIBRARY_DOCS.replace(":id", id);
};
export const DATA_LIBRARY_LENS = `${DATA_LIBRARY}/:id/lens`;
export const resolveDataLibraryLens = (id) => {
  return DATA_LIBRARY_LENS.replace(":id", id);
};

// Tools items
export const TOOLS_ITEMS = `${PRIVATE_BASE}/tools-items`;
export const CLIENTS_ADMINISTRATION = `${TOOLS_ITEMS}/clients-administration`;
export const CLIENTS_ADMINISTRATION_BY_ID = `${CLIENTS_ADMINISTRATION}/:id`;
export const resolveClientAdministrationById = (id) => {
  return CLIENTS_ADMINISTRATION_BY_ID.replace(":id", id);
};
export const CLIENT_PLATFORM_MARGINS = `${TOOLS_ITEMS}/client-platform-margins`;
export const CLIENT_PLATFORM_MARGINS_CHANGELOG = `${CLIENT_PLATFORM_MARGINS}/changelog`;
// todo: temporal, fusion de datasets centre y security centre
export const DATASETS_CENTRE = "/adq/datasets-centre";
export const DATASETS_CENTRE_DETAILS = "/adq/datasets-centre/:id";
export const resolveDatasetsCentreDetailRoute = (id) =>
  `/adq/datasets-centre/${id}`;
export const SECURITY_CENTRE = "/adq/security-centre";
export const SECURITY_CENTRE_USERS = "/adq/security-centre/users";
export const SECURITY_CENTRE_USERS_BY_ID = "/adq/security-centre/users/:id";
export const SECURITY_CENTRE_ROLES = "/adq/security-centre/roles";
export const SECURITY_CENTRE_ROLES_BY_ID = "/adq/security-centre/roles/:id";
export const resolveRoleDetail = (id) => `/adq/security-centre/roles/${id}`;
export const SECURITY_CENTRE_PERMISSIONS_DATAAPI =
  "/adq/security-centre/permissions/dataapi";
export const SECURITY_CENTRE_PERMISSIONS_CONTROLCENTRE =
  "/adq/security-centre/permissions/controlcentre";
export const SECURITY_CENTRE_PERMISSIONS_CC_SECTIONS =
  "/adq/security-centre/permissions/controlcentre/sections";
export const SECURITY_CENTRE_PERMISSIONS_CC_ACCESSLEVEL =
  "/adq/security-centre/permissions/controlcentre/accesslevel";
export const resolveSecurityCentreUserDetail = (id) =>
  `/adq/security-centre/users/${id}`;

// Settings
export const SETTINGS = `${PRIVATE_BASE}/settings`;

// Data quality
export const DATA_QUALITY = `${PRIVATE_BASE}/data-quality`;
export const DQ_LAST_EVALUATION = `${DATA_QUALITY}/last-evaluation`;
export const DQ_EVALUATION_HISTORY = `${DATA_QUALITY}/evaluation-history`;

// Actions performance
export const ACTIONS_PERFORMANCE = `${PRIVATE_BASE}/actions-performance`;
export const ACTIONS_PERFORMANCE_DOWNLOAD = `${ACTIONS_PERFORMANCE}/download`;

// Objectives tracker
export const OBJECTIVES_TRACKER = `${PRIVATE_BASE}/objectives-tracker`;
export const OBJECTIVES_TRACKER_DETAIL = `${OBJECTIVES_TRACKER}/:id`;
export const resolveObjectivesTrackerDetailRoute = (id) => {
  return OBJECTIVES_TRACKER_DETAIL.replace(":id", id);
};

// Wildcards
export const ANY_PAGE = "*";
